import { DatabaseOutlined } from '@ant-design/icons-vue'

export default [
  {
    path: '/operation',
    name: 'operation',
    redirect: '/operation/fallCalibration',
    meta: { title: '运维管理', sort: 4, icon: DatabaseOutlined, isFullScreen: false, prem: true },
    children: [
      {
        path: '/operation/fallCalibration',
        name: 'operationFallCalibration',
        component: () => import('@/views/system/fallHistory/index.vue'),
        meta: {
          title: '设备校准',
          sort: 3,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/fallEvent',
        name: 'operationFallEvent',
        component: () => import('@/views/alarm/fallHistory/index.vue'),
        meta: {
          title: '跌倒事件',
          sort: 4,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/deviceStock',
        name: 'operationDeviceStock',
        component: () => import('@/views/operation/deviceStock/index.vue'),
        meta: {
          title: '设备备案',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/installDispatch',
        name: 'operationInstallDispatch',
        component: () => import('@/views/operation/installDispatch/index.vue'),
        meta: {
          title: '安装外发',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/installAudit',
        name: 'operationInstallAudit',
        component: () => import('@/views/operation/installAudit/index.vue'),
        meta: {
          title: '安装审核',
          sort: 5,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/installAudit/detail',
        name: 'operationInstallAuditDetail',
        component: () => import('@/views/operation/installAudit/detail.vue'),
        meta: {
          title: '安装审核详情',
          sort: 6,
          isFullScreen: false,
          keepAlive: false,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/sceneEvaluation',
        name: 'operationSceneEvaluation',
        component: () => import('@/views/operation/sceneEvaluation/index.vue'),
        meta: {
          title: '安装场景评估',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/deviceAcceptance',
        name: 'operationDeviceAcceptance',
        component: () => import('@/views/operation/deviceAcceptance/index.vue'),
        meta: {
          title: '设备验收',
          sort: 6,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/multiSync',
        name: 'operationMultiSync',
        component: () => import('@/views/operation/multiSync/index.vue'),
        meta: {
          title: '多端同步',
          sort: 7,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/feedback',
        name: 'operationFeedback',
        component: () => import('@/views/operation/feedback/index.vue'),
        meta: {
          title: '用户反馈',
          sort: 8,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/guardReport',
        name: 'operationGuardReport',
        component: () => import('@/views/operation/guardReport/index.vue'),
        meta: {
          title: '运营守护报告',
          sort: 9,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/deviceOpsReport',
        name: 'operationDeviceOpsReport',
        component: () => import('@/views/operation/deviceOpsReport/index.vue'),
        meta: {
          title: '设备运维报告',
          sort: 10,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/article',
        name: 'operationArticle',
        component: () => import('@/views/operation/article/index.vue'),
        meta: {
          title: '健康科普文章',
          sort: 10,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
      {
        path: '/operation/discuss',
        name: 'operationDiscuss',
        component: () => import('@/views/operation/discuss/index.vue'),
        meta: {
          title: '评论管理',
          sort: 11,
          isFullScreen: false,
          keepAlive: true,
          hidden: false,
          prem: true,
        },
      },
    ],
  },
]
